import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const ELEMENT_NOT_ACTIVE_CLR = '#151514';
export const ELEMENT_NOT_ACTIVE_CLR_HOVER = Colors.zelWhite10;

export const Wrapper = styled(FlexBox)`
    width: 100%;
    //margin-bottom: 24px;
`;

export const CircleContainer = styled.div`
    position: relative;
    height: 98px;
    width: 100%;

    @media(max-width: ${LayoutConst.screen.m}px) {
        height: 62px;
    }
`;

export const Circle = styled.div<{ offset: number, color: string, hover: string, isActive: boolean, leyer?: number }>`
    position: absolute;
    // background-color: ${({ color, isActive }) => isActive ? color : ELEMENT_NOT_ACTIVE_CLR};
    // transition: background-color 0.2s;

    svg path:first-of-type {
        fill: ${({ color, isActive }) => isActive ? color : ELEMENT_NOT_ACTIVE_CLR};
        transition: fill 0.2s;
    }
    top: 0;
    left: ${({ offset }) => `${offset}px` || 0};
    width: 97px;
    height: 97px;
    // text-align: center;
    // display: flex;
    // justify-content: center;
    // place-items: center;
    // border-radius: 50%;
    z-index: ${({ isActive, leyer }) => leyer};
    // color: #fff;
    // font-size: 60px;
    // line-height: 70px;
    cursor: pointer;

    &:hover {
        svg path:first-of-type {
            fill: ${({ hover, isActive, color }) => isActive ? hover : ELEMENT_NOT_ACTIVE_CLR_HOVER};
            transition: fill 0.2s;
        }
        // background-color: ${({ hover, isActive, color }) => isActive ? color : hover};
        // transition: background-color 0.2s;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        height: 62px;
        width: 62px;
        font-size: 20px;
        line-height: 28px;
    }
`;import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const ELEMENT_NOT_ACTIVE_CLR = '#151514';
export const ELEMENT_NOT_ACTIVE_CLR_HOVER = Colors.zelWhite10;

export const Wrapper = styled(FlexBox)`
    width: 100%;
    //margin-bottom: 24px;
`;

export const CircleContainer = styled.div`
    position: relative;
    height: 98px;
    width: 100%;

    @media(max-width: ${LayoutConst.screen.m}px) {
        height: 62px;
    }
`;

export const Circle = styled.div<{ offset: number, color: string, hover: string, isActive: boolean, leyer?: number }>`
    position: absolute;
    // background-color: ${({ color, isActive }) => isActive ? color : ELEMENT_NOT_ACTIVE_CLR};
    // transition: background-color 0.2s;

    svg path:first-of-type {
        fill: ${({ color, isActive }) => isActive ? color : ELEMENT_NOT_ACTIVE_CLR};
        transition: fill 0.2s;
    }
    top: 0;
    left: ${({ offset }) => `${offset}px` || 0};
    width: 97px;
    height: 97px;
    // text-align: center;
    // display: flex;
    // justify-content: center;
    // place-items: center;
    // border-radius: 50%;
    z-index: ${({ isActive, leyer }) => leyer};
    // color: #fff;
    // font-size: 60px;
    // line-height: 70px;
    cursor: pointer;

    &:hover {
        svg path:first-of-type {
            fill: ${({ hover, isActive, color }) => isActive ? hover : ELEMENT_NOT_ACTIVE_CLR_HOVER};
            transition: fill 0.2s;
        }
        // background-color: ${({ hover, isActive, color }) => isActive ? color : hover};
        // transition: background-color 0.2s;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        height: 62px;
        width: 62px;
        font-size: 20px;
        line-height: 28px;
    }
`;